import { withFormsy } from 'formsy-react';
import React from 'react';
import { StyldedTextInput, StyldedError } from './styled';


class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }
 
  changeValue(event) {
    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.
    this.props.setValue(event.currentTarget.value);
  }

 
  render() {

    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    var className = this.props.showError() ? 'error' : '';
    return (
      <div className={className}>
        <StyldedTextInput
          onChange={this.changeValue}
          type="text"
          className={this.props.isPristine()?'':this.props.isValid()?'':'error'}
          placeholder={this.props.placeholder || ''}
          value={this.props.getValue() || ''}
        />
       
        <StyldedError>{ this.props.isPristine()?'':this.props.isValid()?'': this.props.displayError?errorMessage:'' }</StyldedError>
      </div>
    );
  }
}
 
export default withFormsy(TextInput);


// WEBPACK FOOTER //
// ./src/elements/Form/Input/TextInput.jsx